import React from 'react';
import { usePreferences } from '../context/UserPreferencesContext';
import './PageShell.css';
import './SettingsPage.css';

function SettingsPage() {
  const {
    targetLanguage,
    setTargetLanguage,
    pauseOnEverySubtitle,
    setPauseOnEverySubtitle,
    pauseIfUnknownWords,
    setPauseIfUnknownWords,
    knownWordIds,
    clearKnownWords,
    skipKnownConfirm,
    setSkipKnownConfirm,
  } = usePreferences();

  const handleClearKnownWords = () => {
    if (knownWordIds.length === 0) return;
    const ok = window.confirm(
      `Clear all ${knownWordIds.length} known words? They will start being highlighted again.`
    );
    if (ok) clearKnownWords();
  };

  return (
    <div className="page-shell">
      <div className="page-shell-inner">
        <p className="page-shell-subtitle">Manage your language and playback preferences</p>

        {/* Target language */}
        <section className="settings-section">
          <h3 className="settings-section-title">Target language</h3>
          <select
            className="settings-select"
            value={targetLanguage}
            onChange={(e) => setTargetLanguage(e.target.value)}
            aria-label="Target language"
          >
            <option value="fr">French</option>
            <option value="de">German</option>
          </select>
          <p className="settings-note">
            This is the language you want to learn. It scopes annotation keys and dictionary content.
          </p>
        </section>

        {/* Source language */}
        <section className="settings-section">
          <h3 className="settings-section-title">Source language</h3>
          <input
            className="settings-input"
            type="text"
            value="English"
            readOnly
            disabled
            aria-label="Source language"
          />
          <p className="settings-note">
            Definitions are shown in English. (Fixed during the preview.)
          </p>
        </section>

        {/* Playback preferences */}
        <section className="settings-section">
          <h3 className="settings-section-title">Playback preferences</h3>

          <label className="settings-toggle-row">
            <input
              type="checkbox"
              checked={pauseOnEverySubtitle}
              onChange={(e) => setPauseOnEverySubtitle(e.target.checked)}
            />
            <span className="settings-toggle-label">
              Pause on each new subtitle (on videos without subtitles: on each annotated word)
            </span>
          </label>

          <label className="settings-toggle-row">
            <input
              type="checkbox"
              checked={pauseIfUnknownWords}
              onChange={(e) => setPauseIfUnknownWords(e.target.checked)}
            />
            <span className="settings-toggle-label">
              Pause only when unknown words are present
            </span>
          </label>

          <p className="settings-note">
            If "pause on each new subtitle" is on, it takes priority over "pause only when unknown
            words are present".
          </p>
        </section>

        {/* Known words */}
        <section className="settings-section">
          <h3 className="settings-section-title">Known words</h3>
          <p className="settings-known-count">
            You have marked <strong>{knownWordIds.length}</strong>{' '}
            {knownWordIds.length === 1 ? 'word' : 'words'} as known.
          </p>
          <div className="settings-known-actions">
            <button
              className="settings-danger-btn"
              onClick={handleClearKnownWords}
              disabled={knownWordIds.length === 0}
            >
              Clear all known words
            </button>
            {skipKnownConfirm && (
              <button
                className="settings-secondary-btn"
                onClick={() => setSkipKnownConfirm(false)}
              >
                Re-enable known-word confirmation
              </button>
            )}
          </div>
        </section>
      </div>
    </div>
  );
}

export default SettingsPage;
